import { BareActionContext } from "vuex-typex";
import { storeBuilder, RootState } from "../RootState";

export type SnackType = "success" | "info" | "error";

export class SnackState {
  text = "";
  type: SnackType = "info";
  show = false;
  timeout = 5000;
}

const b = storeBuilder.module<SnackState>("snack", new SnackState());

// getters
const text = b.read(state => state.text, "text");
const type = b.read(state => state.type, "type");
const show = b.read(state => state.show, "show");
const timeout = b.read(state => state.timeout, "timeout");

export const getters = {
  get text() {
    return text();
  },
  get show() {
    return show();
  },
  get type() {
    return type();
  },
  get timeout() {
    return timeout();
  }
};

// mutations
export const mutations = {
  showSnack: b.commit(showSnack),
  hideSnack: b.commit(hideSnack),
  setText: b.commit(setText),
  setType: b.commit(setType)
};

function showSnack(state: SnackState) {
  state.show = true;
}
function hideSnack(state: SnackState) {
  state.show = false;
}
function setText(state: SnackState, text: string) {
  state.text = text;
}
function setType(state: SnackState, type: SnackType) {
  state.type = type;
}

// actions
type ActionContext = BareActionContext<SnackState, RootState>;

export const actions = {};
